export const parseDateOnlyFormat = (date: string) => {
  let dateObject = new Date(date)
  if (!isNaN(dateObject.getTime())) {
    let formatDate = new Intl.DateTimeFormat('es', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      timeZone: 'UTC',
    })
    return formatDate.format(dateObject)
  }
  return null
}
